import React from 'react'

import useParticipants from 'hooks/useParticipants/useParticipants'

import AudioTrack from './AudioTrack'

/* This component creates audio elements for all participants in the room */

const AudioTracks = () => {
    const { participants } = useParticipants()

    return participants.map(participant => (
        <AudioTrack
            key={`audio-${participant.identity}`}
            participant={participant}
        />
    ))
}

export default AudioTracks
